var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionTypeRkImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 109,
    viewBox: "0 0 125 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 25.7896,
    y: 16.7539,
    width: 83.2247,
    height: 64.9945,
    rx: 2.77093,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.2059,
    y: 16.2547,
    width: 82.5512,
    height: 64.321,
    rx: 2.4342,
    stroke: "black",
    strokeWidth: 0.673465,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19452_3300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.1238 68.2963H96.9193V52.8651C96.9193 51.6957 96.4548 50.5743 95.628 49.7475C94.8011 48.9206 93.6797 48.4561 92.5104 48.4561H81.4881V28.616C81.4881 27.4466 81.0236 26.3252 80.1967 25.4984C79.3699 24.6715 78.2485 24.207 77.0791 24.207H59.4434C58.2741 24.207 57.1527 24.6715 56.3259 25.4984C55.499 26.3252 55.0345 27.4466 55.0345 28.616V37.4338H44.0122C42.8429 37.4338 41.7214 37.8983 40.8946 38.7252C40.0678 39.552 39.6033 40.6734 39.6033 41.8427V68.2963H37.3988C36.8141 68.2963 36.2534 68.5285 35.84 68.942C35.4266 69.3554 35.1943 69.9161 35.1943 70.5008C35.1943 71.0854 35.4266 71.6461 35.84 72.0595C36.2534 72.473 36.8141 72.7052 37.3988 72.7052H99.1238C99.7084 72.7052 100.269 72.473 100.683 72.0595C101.096 71.6461 101.328 71.0854 101.328 70.5008C101.328 69.9161 101.096 69.3554 100.683 68.942C100.269 68.5285 99.7084 68.2963 99.1238 68.2963ZM55.0345 68.2963H44.0122V41.8427H55.0345V68.2963ZM71.568 50.6606C71.568 51.2452 71.3357 51.806 70.9223 52.2194C70.5089 52.6328 69.9482 52.8651 69.3635 52.8651C68.7789 52.8651 68.2181 52.6328 67.8047 52.2194C67.3913 51.806 67.1591 51.2452 67.1591 50.6606V42.697L66.754 42.832C66.4793 42.9235 66.1893 42.9601 65.9005 42.9396C65.6118 42.9191 65.3298 42.8418 65.0709 42.7124C64.8119 42.5829 64.581 42.4037 64.3913 42.185C64.2016 41.9663 64.0569 41.7123 63.9653 41.4377C63.8738 41.163 63.8372 40.873 63.8577 40.5842C63.8783 40.2954 63.9555 40.0135 64.085 39.7546C64.2144 39.4956 64.3936 39.2647 64.6124 39.075C64.8311 38.8853 65.085 38.7406 65.3597 38.649L68.6664 37.5468C68.9977 37.4363 69.3506 37.4062 69.696 37.4589C70.0413 37.5115 70.3692 37.6455 70.6525 37.8498C70.9359 38.054 71.1667 38.3227 71.3259 38.6337C71.485 38.9446 71.568 39.289 71.568 39.6383V50.6606ZM92.5104 68.2963H81.4881V52.8651H92.5104V68.2963Z",
    fill: "#E3DFE9"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.07031 57.8963L76.4477 18.6094L8.07031 57.8963Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.538 34.1237L115.867 31.0215L110.538 34.1237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5674 88.4333L54.8965 85.3311",
    stroke: "#E3DFE9",
    strokeWidth: 16.7314,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.1 77.4601C113.932 77.5469 114.537 78.2927 114.45 79.1244C114.363 79.956 113.617 80.5608 112.786 80.474C111.954 80.3871 111.349 79.6414 111.436 78.8097C111.523 77.978 112.269 77.3732 113.1 77.4601Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.778901
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4598 94.8964C32.8274 95.0392 33.8219 96.2656 33.6791 97.6332C33.5363 99.0009 32.3099 99.9954 30.9423 99.8526C29.5746 99.7098 28.5802 98.4834 28.723 97.1158C28.8658 95.7481 30.0921 94.7536 31.4598 94.8964Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.28085
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5911 6.89057C60.9588 7.03337 61.9532 8.25973 61.8104 9.62737C61.6676 10.995 60.4413 11.9895 59.0736 11.8467C57.706 11.7039 56.7115 10.4776 56.8543 9.10991C56.9971 7.74226 58.2235 6.74777 59.5911 6.89057Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.28085
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90608 38.6621C2.53429 38.6621 3.04434 39.1722 3.04434 39.8004C3.04434 40.4286 2.53429 40.9386 1.90608 40.9386C1.27788 40.9386 0.767822 40.4286 0.767822 39.8004C0.767822 39.1722 1.27788 38.6621 1.90608 38.6621Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.936249
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.457 31.1611C123.085 31.1611 123.595 31.6712 123.595 32.2994C123.595 32.9276 123.085 33.4377 122.457 33.4377C121.828 33.4377 121.318 32.9276 121.318 32.2994C121.318 31.6712 121.828 31.1611 122.457 31.1611Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.936249
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.298 5.86426L104.598 1.48421",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.831 3.05566L106.211 4.35508",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52197 80.4473L7.66121 76.0229",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95239 77.6934L9.3768 78.8326",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M101.492 100.213L102.384 95.7319",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7725 97.5508L104.253 98.4419",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTypeRkImg);
export default __webpack_public_path__ + "static/media/question_type_rk_img.16517af6e7ee614559748c5f089036f0.svg";
export { ForwardRef as ReactComponent };